<footer class="cn-footer">
  <div class="cn-footer__inner cn-container cn-container--wide">
    <div class="cn-footer__top">
      <div class="cn-footer__brand">
        <img src="logo-full-white.png" alt="ChircalNet Telecom" style="height:34px;width:auto;display:block" />
        <p>Fibra simétrica para hogares y empresas. Conectividad que impulsa tu mundo.</p>
        <div class="cn-footer__social">
          @for (s of social; track s.label) {
            <a [href]="s.href" [attr.aria-label]="s.label"
               [attr.target]="s.href !== '#' ? '_blank' : null"
               [attr.rel]="s.href !== '#' ? 'noopener noreferrer' : null"
               [innerHTML]="s.icon"></a>
          }
        </div>
      </div>

      @for (col of columns; track col.title) {
        <div class="cn-footer__col">
          <h4>{{ col.title }}</h4>
          <ul>
            @for (link of col.links; track link) {
              <li><a href="#">{{ link }}</a></li>
            }
          </ul>
        </div>
      }
    </div>

    <div class="cn-footer__bottom">
      <span>© {{ year }} ChircalNet Telecom. Todos los derechos reservados.</span>
      <span class="cn-footer__conatel">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
        Habilitados por CONATEL · HGTS-00590
      </span>
    </div>
  </div>
</footer>
